import { render, staticRenderFns } from "./ren.vue?vue&type=template&id=e63652c8"
import script from "./ren.vue?vue&type=script&lang=ts"
export * from "./ren.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports